import { render, staticRenderFns } from "./CallTableDepositsActions.vue?vue&type=template&id=3106aa97&scoped=true"
import script from "./CallTableDepositsActions.vue?vue&type=script&lang=js"
export * from "./CallTableDepositsActions.vue?vue&type=script&lang=js"
import style0 from "./CallTableDepositsActions.vue?vue&type=style&index=0&id=3106aa97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106aa97",
  null
  
)

export default component.exports